import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';
import { Button } from '../components/Button';
import { Card } from '../components/Card';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <main className="grid h-screen place-items-center px-4">
      <Card variant="elevated" className="w-full max-w-sm space-y-3 p-8 text-center">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-text-muted">404</p>
        <h1 className="font-[var(--font-serif)] text-2xl font-bold italic text-text-primary">Page not found</h1>
        <div className="pt-2">
          <Button variant="ghost" onClick={() => void navigate('/hosts')}>
            <ArrowLeft className="h-4 w-4" />
            Back to hosts
          </Button>
        </div>
      </Card>
    </main>
  );
}
